import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/serviceSalesSaga";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

const IncludeReturns = () => {
  const dispatch = useDispatch();
  const isActive = useSelector((state) => state.serviceSales.selectedFilters.include_returns);

  return (
    <ToggleableButton
      isActive={isActive}
      isRadio
      title="toggle-revenue"
      onClick={(data) => dispatch(actionCreators.updateShowNetRevenue(data))}
    />
  );
};

export default IncludeReturns;
